var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("AppHeader", { attrs: { dropdownItems: _vm.dropdownItems } }),
      _vm._v(" "),
      _vm.showNavigator
        ? _c("Navigator", {
            attrs: { title: _vm.routeTitle, navItems: _vm.nav }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "app-body" }, [
        _c("main", { staticClass: "main" }, [
          _c("div", { staticClass: "container-fluid" }, [_c("router-view")], 1)
        ])
      ]),
      _vm._v(" "),
      _c("AppFooter"),
      _vm._v(" "),
      _c("FaqModal"),
      _vm._v(" "),
      _c("EventModal"),
      _vm._v(" "),
      _c("CustomMessageModal"),
      _vm._v(" "),
      _c("EventDetailModal"),
      _vm._v(" "),
      _c("ModalInfo"),
      _vm._v(" "),
      _c("ManageEmailModal"),
      _vm._v(" "),
      _c("EmailHistoriesManagement"),
      _vm._v(" "),
      _c("EventStaffingDetail")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-95a64098", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95a64098","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/manager/Dashboard.vue
// module id = 1734
// module chunks = 1